import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=24ac097e&scoped=true"
import script from "./Zonas.vue?vue&type=script&lang=js"
export * from "./Zonas.vue?vue&type=script&lang=js"
import style0 from "./Zonas.vue?vue&type=style&index=0&id=24ac097e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac097e",
  null
  
)

export default component.exports